<ng-container *ngIf="{ config: config$ | async, heatPumps: heatPumps$ | async } as resolved">
  <lib-block-title
    id="heatpump-config-title"
    [title]="labels.title">
  </lib-block-title>
  <!-- Selettore pompa di calore (solo se più di una) -->
  <ng-container *ngIf="resolved.heatPumps as heatPumps">
    <section
      *ngIf="heatPumps.length > 1"
      class="custom-section">
      <customer-title-content
        [title]="labels.heatPumpSelectorTitle">
      </customer-title-content>
      <mat-form-field
        subscriptSizing="dynamic"
        class="custom-mat-form-field w-full custom-border-bottom">
        <mat-select
          [placeholder]="labels.heatPumpSelectorPlaceholder"
          [value]="heatPumpId$ | async"
          (selectionChange)="heatPumpId$.next($event.value)" >
          <mat-option
            *ngFor="let hp of heatPumps"
            [value]="hp.sn">
            {{ hp.sn }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </section>
  </ng-container>
  <ng-container *ngIf="resolved.heatPumps && resolved.heatPumps.length === 0; else hasHeatPumps">
    <section class="fx-col w-full fx-gap-3">
      <div class="fx-row fx-justify-evenly fx-wrap fx-gap-3 text-yellow-400 text-300 body-2">
        <section class="border-1 fx-center fx-gap-3 p-1 radius-4 radius-2 border-yellow-100 w-full">
          <mat-icon class="text-orange-400">
            info
          </mat-icon>
          <customer-title-content
            class="fx-g-1"
            [content]="labels.noHeatpumpWarning">
          </customer-title-content>
        </section>
      </div>
      <lib-azzurro-hub-rescan
        id="rescan-devices-button"
        [deviceId]="hubId"
        [labels]="{
          startRescan: labels.startRescan,
          rescanningMessage: labels.rescanningMessage,
          rescanDisclaimerTitle: labels.rescanDisclaimerTitle,
          rescanDisclaimerText: labels.rescanDisclaimerText
        }"
        [canRescan]="(canRescan$ | async) || false">
      </lib-azzurro-hub-rescan>
      <p class="fx-center text-grey-400 tw-text-sm">
        {{ labels.orLabel }}
      </p>
      <p class="tw-text-sm fx-center fx-gap-1 text-grey-400">
        {{ labels.moreInfoPrefix }}
        <a
          href="https://www.zcsazzurro.com/it/inverters/heat-pump"
          target="_blank"
          class="text-accent-700"
          rel="noopener noreferrer">
          {{ labels.moreInfoLink }}
        </a>
        {{ labels.moreInfoSuffix }}
      </p>
    </section>
  </ng-container>

  <ng-template #hasHeatPumps>
    <ng-container *ngIf="resolved.config; else skeletonView">
      <p class="mt-3 mb-6 text-grey-400 text-normal-wrap tw-text-sm tw-font-normal">
        {{ labels.description }}
      </p>
      <form
        class="fx-row fx-wrap fx-gap-3"
        [formGroup]="form">
        <!-- Acqua calda sanitaria (DHW) -->
        <section class="custom-section">
          <customer-title-content
            [title]="labels.dhwTitle"
            [content]="labels.dhwDescription">
          </customer-title-content>

          <div class="fx-row fx-gap-3 fx-align-center mb-3">
            <mat-slide-toggle
              formControlName="DHWOn"
              class="m-0 my-3">
            </mat-slide-toggle>
            <customer-title-content
              [content]="labels.dhwToggleLabel">
            </customer-title-content>
          </div>

          <div
            class="mt-3"
            [ngClass]="{'disabled-section': !dhwOnCtrl?.value}">
            <customer-title-content
              [title]="labels.dhwSetTempTitle">
            </customer-title-content>
            <mat-form-field
              subscriptSizing="dynamic"
              class="custom-mat-form-field w-full custom-border-bottom">
              <input
                matInput
                type="number"
                formControlName="DHWSetTemp" />
              <mat-error *ngIf="dhwSetTempCtrl?.hasError('required')">
                {{ labels.genericRequiredFieldError }}
              </mat-error>
              <mat-error *ngIf="dhwSetTempCtrl?.hasError('min') || dhwSetTempCtrl?.hasError('max')">
                {{ labels.dhwTempValidatorsError }}
              </mat-error>
            </mat-form-field>
          </div>
        </section>

        <!-- Climatizzazione -->
        <section class="custom-section">
          <customer-title-content
            [title]="labels.climateTitle"
            [content]="labels.climateDescription">
          </customer-title-content>

          <div class="fx-row fx-gap-3 fx-align-center mb-3">
            <mat-slide-toggle
              formControlName="climOnA"
              class="m-0 my-3">
            </mat-slide-toggle>
            <customer-title-content
              [content]="labels.climateToggleLabel">
            </customer-title-content>
          </div>

          <div
            class="mt-3 fx-col fx-gap-3"
            [ngClass]="{'disabled-section': !climOnACtrl?.value}">
            <customer-title-content
              [title]="labels.climateModeTitle">
            </customer-title-content>
            <mat-form-field
              subscriptSizing="dynamic"
              class="custom-mat-form-field w-full custom-border-bottom">
              <mat-select
                formControlName="climOpMode"
                placeholder="labels.climateModePlaceholder">
                <mat-option
                  [value]="AHclimOpModeEnum.Cooling">
                  {{ labels.climateModeCoolingLabel }}
                </mat-option>
                <mat-option
                  [value]="AHclimOpModeEnum.Heating">
                  {{ labels.climateModeHeatingLabel }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="climOpModeCtrl?.hasError('required')">
                {{ labels.genericRequiredFieldError }}
              </mat-error>
            </mat-form-field>

            <customer-title-content
              [title]="labels.heatingTempTitle">
            </customer-title-content>
            <mat-form-field
              subscriptSizing="dynamic"
              class="custom-mat-form-field w-full custom-border-bottom">
              <input
                matInput
                type="number"
                formControlName="climSetTempHeatingA" />
              <mat-error *ngIf="climSetTempHeatingACtrl?.hasError('required')">
                {{ labels.genericRequiredFieldError }}
              </mat-error>
              <mat-error *ngIf="climSetTempHeatingACtrl?.hasError('min') || climSetTempHeatingACtrl?.hasError('max')">
                {{ labels.heatingTempValidatorsError }}
              </mat-error>
            </mat-form-field>

            <customer-title-content
              [title]="labels.coolingTempTitle">
            </customer-title-content>
            <mat-form-field
              subscriptSizing="dynamic"
              class="custom-mat-form-field w-full custom-border-bottom">
              <input
                matInput
                type="number"
                formControlName="climSetTempCoolingA" />
              <mat-error *ngIf="climSetTempCoolingACtrl?.hasError('required')">
                {{ labels.genericRequiredFieldError }}
              </mat-error>
              <mat-error *ngIf="climSetTempCoolingACtrl?.hasError('min') || climSetTempCoolingACtrl?.hasError('max')">
                {{ labels.coolingTempValidatorsError }}
              </mat-error>
            </mat-form-field>
          </div>
        </section>

        <div class="fx-b-1 fx-gap-3 fx-justify-end fx-row mt-6 w-full">
          <button
            class="custom-mat-button-secondary"
            mat-button
            type="button"
            (click)="onReset()">
            {{ labels.reset }}
          </button>
          <button
            class="custom-mat-button-primary ml-0"
            mat-button
            type="button"
            [disabled]="form.invalid"
            (click)="onSave()">
            {{ labels.save }}
          </button>
        </div>
      </form>
    </ng-container>
  </ng-template>
</ng-container>

<ng-template #skeletonView>
  <div class="fx-row fx-wrap fx-gap-3">
    <ion-skeleton-text
      *ngFor="let _ of [].constructor(2)"
      class="h-100"
      style="border-radius: 4px; flex-basis: 300px; flex-grow: 2;"
      [animated]="true">
    </ion-skeleton-text>
    <div class="fx-row fx-justify-end fx-align-center fx-gap-3 mt-6 w-full">
      <ion-skeleton-text
        class="w-40 h-20"
        style="border-radius: 4px;"
        [animated]="true">
      </ion-skeleton-text>
      <ion-skeleton-text
        class="w-40 h-20"
        style="border-radius: 4px;"
        [animated]="true">
      </ion-skeleton-text>
    </div>
  </div>
</ng-template>
